import { makeStyles, Theme } from '@material-ui/core/styles'

import { COLORS } from 'styles'

const useStyles = makeStyles((theme: Theme) => ({
  root: {
    display: 'flex',
  },
  appBar: {
    zIndex: theme.zIndex.drawer + 1,
  },
  drawer: {
    width: 240,
    flexShrink: 0,
    whiteSpace: 'nowrap',
    transition: theme.transitions.create('width', {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.enteringScreen,
    }),
  },
  drawerCollapsed: {
    width: theme.spacing(7) + 1,
    transition: theme.transitions.create('width', {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.leavingScreen,
    }),
  },
  drawerPaper: {
    width: 240,
    transition: theme.transitions.create('width', {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.enteringScreen,
    }),
    overflowX: 'hidden',
    '&::-webkit-scrollbar': {
      width: '6px',
    },
    '&::-webkit-scrollbar-track': {
      background: 'transparent',
    },
    '&::-webkit-scrollbar-thumb': {
      background: '#bbb',
      borderRadius: '3px',
    },
    '&::-webkit-scrollbar-thumb:hover': {
      background: '#aaa',
    },
  },
  drawerPaperCollapsed: {
    width: theme.spacing(7) + 1,
    overflowX: 'hidden',
    overflowY: 'hidden',
    transition: theme.transitions.create('width', {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.leavingScreen,
    }),
  },
  content: {
    flexGrow: 1,
    padding: theme.spacing(3),
  },
  toolbar: theme.mixins.toolbar,
  list: {
    flex: 1,
    '& .MuiListItemText-primary': {
      fontFamily: 'Montserrat',
      fontWeight: 400,
      fontSize: '14px',
    },
  },
  login: {
    marginLeft: 'auto',
  },
  link: {
    textDecoration: 'none',
    color: COLORS.GRAY,
    fontStyle: '400',
    '& .MuiListItemText-primary': {
      fontFamily: 'Montserrat',
      fontWeight: 400,
      fontSize: '14px',
    },
  },
  activeLink: {
    textDecoration: 'none',
    color: COLORS.DARK_GREY,
    fontStyle: '400',
    '& .MuiListItemText-primary': {
      fontFamily: 'Montserrat',
      fontWeight: 400,
      fontSize: '14px',
    },
  },
  icon: {
    marginBottom: 4,
    marginTop: 4,
  },
  bottomSection: {
    marginTop: 'auto',
    paddingBottom: 16,
    // borderTop: '1px solid #e0e0e0',
  },
  logoContainer: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    padding: '16px 8px',
  },
  logo: {
    maxWidth: 120,
    height: 'auto',
  },
  logoutButton: {
    justifyContent: 'center',
    textAlign: 'center',
    width: '100%',
    '& .MuiListItemText-root': {
      textAlign: 'center',
    },
    '&:hover': {
      backgroundColor: 'rgba(0, 0, 0, 0.04)',
    },
  },
  logoutButtonCollapsed: {
    justifyContent: 'center',
    minHeight: 48,
    '&:hover': {
      backgroundColor: 'rgba(0, 0, 0, 0.04)',
    },
  },
}))

export { useStyles }
